<template>
  <div class="container" ref="canvas">
  </div>
</template>

<script>
import Draw from '../common/draw-utils'

export default {
  name: 'FetalMonitorAtlasView',
  props: {
    index: {
      type: Number,
      required: true
    },
    cm: {
      type: Number,
      required: true
    },
    bedMode: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      canvas: null,
      canvasCtx: null,
      originalWidth: 0,
      height: 0
    }
  },
  watch: {},
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
    },
    resize (width, height) {
      if (this.originalWidth === width && this.height === height) {
        return false
      }

      this.originalWidth = width
      this.height = height
      // console.log('atlas view resize:: ', width, height)
      return true
    },
    onResize (width, height) {
      this.$refs.canvas.style.width = width + 'px'
      this.$refs.canvas.style.height = height + 'px'
      const ratio = window.devicePixelRatio
      // console.log('radio', ratio)
      if (this.canvas === null) {
        this.canvas = Draw.createCanvas(width, height, ratio)
        this.$refs.canvas.appendChild(this.canvas)
        this.canvasCtx = this.canvas.getContext('2d')
      } else {
        this.canvas.width = parseInt(width * ratio, 10)
        this.canvas.height = parseInt(height * ratio, 10)
        this.canvas.style.width = width + 'px'
        this.canvas.style.height = height + 'px'
        this.canvasCtx.setTransform(ratio, 0, 0, ratio, 0, 0)
      }
    },
    onImage (img) {
      if (img) {
        if (this.canvasCtx) {
          this.canvasCtx.drawImage(img, 0, 0, img.width / window.devicePixelRatio, img.height / window.devicePixelRatio)
        } else {
          console.log('main thread::canvas context null')
        }
      }
    },
    paramChange (isRedrawn, data) {
    },
    receiveData (data) {
    }
  },
  destroyed () {
    console.log('FetalMonitorAtlasView destroyed.')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body, div {
  margin: 0;
  padding: 0;
  border: 0;
}

.container {
  background: #fff;
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
}
</style>
